import React, { Component } from "react";
import Loader from "../../../loader";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import customStyle from "../../../../Assets/CSS/stylesheet_UHS";
import Button from "@material-ui/core/Button";
import axios from "axios";
import configurations from "../../../../configurations";
import { connect } from "react-redux";
import moment from "moment";

const ACSMCheckbox = withStyles({
  root: {
    color: "#1a2c40",
    "&$checked": {
      color: "#1a2c40",
    },
    "&$disabled": {
      color: "grey",
    },
  },
  checked: {},
  disabled: {
    color: "grey",
  },
})(Checkbox);

const styles = (props) => customStyle.chkEligiScreen;

const ProceedButton = withStyles(customStyle.proceedBtn)(Button);

const BackButton = withStyles(customStyle.backBtn)(Button);

// Carrier drives which stepper/quote this session belongs to: "Sharing Programs" => UHF, "Insurance Plans" => VERA.
const getStepperTypeFromCookies = (cookiesData) => {
  return cookiesData.carrier || "UHF";
};

class AddOnsScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaderShow: true,
      corePlan: null,
      addons: [],
      effectiveDate: moment().format("YYYY-MM-DD"),
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    sessionStorage.setItem("current_screen", String(this.props.activeStep));
    let subId = (JSON.parse(localStorage.getItem("CurrentLoginUser") || "null") || {}).id;
    axios
      .get(
        configurations.baseUrl +
          "/enrollment/saveCompletionStatus/" +
          subId +
          "/" +
          this.props.activeStep
      )
      .then((response) => {
        if (response && response.data.code === 200)
          console.log(response.data.code);
      })
      .catch((error) => console.log(error));
    this.fetchAddOns();
  }

  // Add-ons live inside the same carriers/plans response the wizard already uses to gate this
  // step (see enrollment.js checkForAddOnStep) — plans with programType "Addon" are add-ons,
  // everything else is the carrier's core plan. Effective date isn't part of that response, so
  // it's read from the same select-program endpoint PlanSelection.js already uses/persists.
  fetchAddOns = () => {
    let cookiesData = JSON.parse(sessionStorage.getItem("STATE_PARAM")) || {};
    let subId = this.props.subId || cookiesData.subID || cookiesData.user_subId;
    let brokerId = cookiesData.brokerId;
    let stepperType = getStepperTypeFromCookies(cookiesData);
    let type = cookiesData.actionType || stepperType;
    if (!subId || !brokerId) {
      this.setState({ loaderShow: false });
      return;
    }

    Promise.all([
      axios.get(
        configurations.baseRootUrl +
          "/veraenroll/api/v1/quote/agent/" +
          brokerId +
          "/carriers?subId=" +
          subId
      ),
      axios.get(
        configurations.baseRootUrl +
          "/veraenroll/api/v1/quote/select-program/" +
          subId +
          "/" +
          brokerId +
          "/" +
          stepperType +
          `?type=${type}`
      ),
    ])
      .then(([carriersResponse, programResponse]) => {
        // Response is a flat array of carriers — core plans are grouped per carrier under
        // types[].plans, and add-ons live in a SEPARATE top-level "addons" array on the carrier
        // itself (they are never mixed into plans / flagged via programType there).
        let carriers = Array.isArray(carriersResponse.data)
          ? carriersResponse.data
          : ((carriersResponse.data && carriersResponse.data.carriers) || []);
        let carrier = carriers.find((c) => c.carrierCode === stepperType);
        let plans = ((carrier && carrier.types) || []).reduce(
          (all, t) => all.concat(t.plans || []),
          []
        );
        let carrierAddons = (carrier && carrier.addons) || [];

        let programData = programResponse.data || {};
        let programs = programData.program || programData.programs || [];
        let selectedProgram = programs.find((p) => p.selected) || null;
        let corePlanFromCarriers = plans.find((p) => !p.addOn && p.selected) || null;
        let corePlan = selectedProgram
          ? { planId: selectedProgram.planId, planCode: selectedProgram.planName }
          : corePlanFromCarriers;

        let addons = carrierAddons.map((p) => ({
          planId: p.planId,
          planCode: p.planCode,
          serviceFee: p.serviceFee,
          link: p.link,
          sellable: p.sellable !== false,
          message: p.message,
          selected: !!p.selected,
        }));

        this.setState({
          corePlan,
          addons,
          effectiveDate: programData.effectiveDate,
          loaderShow: false,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loaderShow: false });
      });
  };

  // Persists the full add-on selection (every add-on, checked or not) alongside the already-chosen
  // core plan — the backend expects one carriers[0] entry with both corePlan and addons together,
  // so corePlan must be resent unmodified or the backend has nothing to associate the add-ons with.
  saveAddOnSelection = (addons) => {
    let cookiesData = JSON.parse(sessionStorage.getItem("STATE_PARAM")) || {};
    let subId = this.props.subId || cookiesData.subID || cookiesData.user_subId;
    let brokerId = cookiesData.brokerId;
    let stepperType = getStepperTypeFromCookies(cookiesData);
    if (!subId || !brokerId || !this.state.corePlan) return;

    axios
      .post(configurations.baseRootUrl + "/veraenroll/api/v1/quote/member-plan/save", {
        subId: subId,
        agentId: brokerId,
        effectiveDate: this.state.effectiveDate,
        carriers: [
          {
            carrierCode: stepperType,
            corePlan: [
              {
                planId: this.state.corePlan.planId,
                planCode: this.state.corePlan.planCode,
              },
            ],
            addons: addons.map((a) => ({
              planId: a.planId,
              planName: a.planCode,
              selected: a.selected,
            })),
          },
        ],
      })
      .catch((error) => console.log(error));
  };

  handleToggleAddOn = (planId) => {
    const addons = this.state.addons.map((a) =>
      a.planId === planId ? { ...a, selected: !a.selected } : a
    );
    this.setState({ addons });
    this.saveAddOnSelection(addons);
  };

  handleProceed = () => {
    this.saveAddOnSelection(this.state.addons);
    this.props.onClick();
  };

  render() {
    const { addons, loaderShow } = this.state;
    return (
      <div style={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
        {loaderShow ? <Loader></Loader> : ""}
        <Grid container style={{ fontFamily: "Roboto, Arial, Helvetica, sans-serif", fontSize: "14px", flexDirection: "column", flex: "1 1 auto" }} spacing={3}>
          <Grid item xs={12}>
            <p style={{ fontSize: "14px", lineHeight: "20px", fontFamily: "Roboto, Arial, Helvetica, sans-serif" }}>
              Review the add-ons available and check the box next to any you&rsquo;d like to include.
  
            </p>
            <div style={{ overflowX: "auto", width: "100%", maxWidth: "100%", paddingRight: "16px", boxSizing: "border-box", marginTop: "16px" }}>
              <div style={customStyle.programCompareScrollBody}>
                <table style={{
                    width:'70%',
                  }}>
                    <thead>
                    <tr>
                      <th style={customStyle.programCompareHeaderCell}>Add-On</th>
                      <th style={customStyle.programCompareHeaderCell}>Fee</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loaderShow ? (
                      <tr>
                        <td style={customStyle.programCompareCell} colSpan={2}><Loader></Loader></td>
                      </tr>
                    ) : addons.length === 0 ? (
                      <tr>
                        <td style={customStyle.programCompareCell} colSpan={2}>No add-ons are available for this enrollment.</td>
                      </tr>
                    ) : addons.map((addon) => (
                      <tr
                        key={addon.planId}
                        style={addon.selected ? customStyle.programCompareRowSelected : customStyle.programCompareRow}
                      >
                        <td style={customStyle.programCompareCell}>
                          <ACSMCheckbox
                            checked={addon.selected}
                            disabled={!addon.sellable}
                            onChange={() => this.handleToggleAddOn(addon.planId)}
                            style={{ padding: 0, marginRight: "8px" }}
                          />
                          {addon.planCode}
                          {!addon.sellable && addon.message && (
                            <div style={{ fontSize: "12px", color: "#b4302f" }}>{addon.message}</div>
                          )}
                        </td>
                        <td style={customStyle.programCompareCell}>
                          <span style={customStyle.programCompareTotal}>
                            {typeof addon.serviceFee === "number" ? `$${addon.serviceFee.toFixed(2)}` : "N/A"}
                          </span>
                          {addon.link && (
                            <span
                              style={customStyle.programCompareViewDetails}
                              onClick={() => window.open(addon.link)}
                            >VIEW DETAILS</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} style={{ marginTop: "auto" }}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "24px" }}>
              <BackButton
                disabled={false}
                variant="contained"
                onClick={this.props.handlePrev}
              >
                BACK
              </BackButton>
              <ProceedButton
                disabled={false}
                variant="contained"
                onClick={this.handleProceed}
              >
                PROCEED
              </ProceedButton>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    subId: state.subId,
    email: state.email,
  };
};

export default withStyles(styles)(connect(mapStateToProps)(AddOnsScreen));
